module.exports = __webpack_public_path__ + "img/bg_mobile-AC.6e042e8f.png";